import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ArrowDownRight } from "lucide-react";

function LineReveal({ children, delay = 0 }) {
  return (
      <span className="mask-line" style={{ paddingBottom: "0.15em" }}>
      <motion.span
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1.05, delay, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export default function Hero() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const titleY = useTransform(scrollYProgress, [0, 1], [0, -60]);

  return (
    <section
      ref={ref}
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] overflow-hidden bg-bg pt-32 pb-24"
    >
      {/* Ambient glow */}
      <div className="hero-glow" style={{ top: "20%", right: "12%" }} />

      <div className="relative max-w-[1600px] mx-auto px-6 sm:px-10 grid grid-cols-12 gap-6 items-end min-h-[80svh]">
        {/* Left: title + copy */}
        <motion.div style={{ y: titleY }} className="col-span-12 lg:col-span-11 relative z-10">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.15 }}
            className="flex items-center gap-4 mb-8"
          >
            <span className="hairline w-16" />
            <span className="eyebrow">Est. 2026 · A Journal of Fine Spirits</span>
          </motion.div>

          <h1
            data-testid="hero-title"
            className="font-display font-medium leading-[1.05] tracking-tight text-[15vw] lg:text-[10.5vw] xl:text-[9.5rem] text-bone pb-4"
          >
            <LineReveal delay={0.15}>Johnny</LineReveal>
            <LineReveal delay={0.3}>
              <em className="italic font-light" style={{ color: "var(--amber)" }}>Dram.</em>
            </LineReveal>
          </h1>

          <div className="mt-10 grid grid-cols-12 gap-6 max-w-4xl">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="col-span-12 sm:col-span-8 font-body text-lg sm:text-xl leading-relaxed text-bone-dim"
            >
              A house devoted to whiskey, spirits and the art of living well.
              Curated items. Handmade barware. Timeless objects. Evenings illuminated by candlelight.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, delay: 0.85 }}
              className="col-span-12 sm:col-span-4 flex sm:justify-end items-end"
            >
              <a href="#top-shelf" data-testid="hero-cta" className="btn-outline">
                Enter The Cellar <ArrowDownRight size={16} />
              </a>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
